import { ApiService } from "../..";

export const resetRejectedSample = (sampleId: string) => {
  return ApiService.baseAction(`rejected-sample/${sampleId}/reset`, {}, "put");
};
